import React from "react";

class Home extends React.Component {
    render() {
      return <h1 className="m-4">.</h1>;
    }
  }

export default Home